import componentFn from '../../styles/objects/component'
import buttonStylesFn from '../button/styles'
import breakTo from '../../styles/tools/breakTo'
export default ({
    colors,
    spacings,
    images,
    fontFamilies,
    fontWeights,
    fontSizes,
    textTransforms,
    layouts
}) => {
    const component = componentFn({
        colors,
        spacings,
        images,
        fontFamilies,
        fontWeights,
        fontSizes,
        textTransforms,
    })
    const styles = {
        'divmain':{
            width:'80%!important',
            marginTop: '58px'
        },
        'divResume': {
            width: '21rem!important'
        },
        'divMobileNum': {
            width: '14rem!important',
            float: 'left',
            //marginTop: '42px'
        },
        'divOTPAlign': {
            //width: '15rem!important',
            float: 'right',
            marginTop: '-40px!important'

        },
        'otpButtonColor': {
            color: '#cecece!important',
            //margin:'0'
        },
        'mobile_otpButtonAlign':{

            marginTop: '4rem!important'
        },
        'buttonOTPEnabled': {
            color: 'white',
            background: '#00B7FF',//'#00a5ff',
            border: colors.button.border.primary
        },
        'otpMsgvisible': {
            display: 'none'
        },
        'otpMsghidden': {
            display: 'block',
            position: 'absolute',
            //marginTop: '44px'
        }

    }


    const buttonStyles = buttonStylesFn({ colors, layouts })
    return { ...component, ...buttonStyles, ...styles }
}


// WEBPACK FOOTER //
// ./components/mobileWithOTPButton/styles.js